import { embedDashboard } from "@superset-ui/embedded-sdk";
import { useEffect } from 'react';
import { supersetService } from '../../../services/superset-service';
import { Config } from "@/core/config/config";


const SUPERSET_DOMAIN = Config.VITE_APP_SUPERSET_URL;


export default function SupersetDashboards() {

    useEffect(() => {
        embedDashboard({
            id: "10c4c491-89f5-487c-ad97-d63e93d05f58",
            supersetDomain: SUPERSET_DOMAIN!,
            mountPoint: document.querySelector("#superset-container")!, 
            fetchGuestToken: () => supersetService.getSalesPerformanceDashboard()
                .then((response) => response.data.token),
            dashboardUiConfig: { hideTitle: true, hideChartControls: false },

        });
    }, [])
    return (

        <div id="superset-container" className="embedded-superset">

        </div>

    );
}